import React from "react";
import MemorialRibbon from "@/components/MemorialRibbon";

// Full-screen commemorative cover shown for ~2s on launch, then cross-dissolves
// to the character selection (flag background persists behind both).
export default function LandingCover({ visible }) {
  return (
    <div
      data-testid="landing-cover"
      style={{
        position: "absolute",
        inset: 0,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 18,
        opacity: visible ? 1 : 0,
        transition: "opacity 1s ease",
        pointerEvents: visible ? "auto" : "none",
        zIndex: 20,
      }}
    >
      <div style={{ position: "absolute", inset: 0, background: "rgba(7,10,20,0.35)" }} />
      <img
        src="/brand/tab_seal.png"
        alt="TAB seal"
        className="tab-glow"
        style={{ width: 150, height: 150, borderRadius: 999, position: "relative", zIndex: 1 }}
      />
      <h1
        className="font-serif-q tab-fade"
        style={{
          position: "relative",
          zIndex: 1,
          margin: 0,
          color: "#f2c85b",
          fontSize: "clamp(30px, 6vw, 62px)",
          fontWeight: 700,
          letterSpacing: "0.03em",
          textShadow: "0 4px 34px rgba(0,0,0,0.9)",
          textAlign: "center",
        }}
      >
        9/11: The Immaculate Salvation
      </h1>
      <div
        className="font-serif-q tab-fade"
        style={{
          position: "relative",
          zIndex: 1,
          color: "#ffffff",
          fontSize: "clamp(16px, 2.6vw, 26px)",
          fontWeight: 500,
          letterSpacing: "0.14em",
          textShadow: "0 3px 24px rgba(0,0,0,0.85)",
          textAlign: "center",
        }}
      >
        We Will Never Forget
      </div>
      <div
        style={{
          position: "relative",
          zIndex: 1,
          color: "rgba(255,255,255,0.75)",
          fontSize: 13,
          letterSpacing: "0.3em",
          textTransform: "uppercase",
        }}
      >
        September 11, 2001 · 25th Anniversary
      </div>
      <div style={{ position: "relative", zIndex: 1, marginTop: 6 }}>
        <MemorialRibbon size={70} />
      </div>
    </div>
  );
}
